import { Alert, Col, Row, Space, Tag } from "antd";
import { CustomCard } from "../../../shared/components/CustomCard/CustomCard";
import {
  billDueDate,
  daysJsFormat,
  iconSwitchStatusControl,
  languagesList,
  renderEmailClickable,
  renderPhoneClickable,
  renderResponsable,
  renderStatusPrestation,
  renderStatusTag,
  renderTypePrestation,
  renderUserGender,
  renderUserName,
  roles,
  statusPrestationsValues,
  subStatus,
  typeIntervention,
  typeSwitchStatusControl,
} from "../../../utils/constants";
import { RenderUpdatedCopy } from "../../../shared/components/RenderUpdatedCopy/RenderUpdatedCopy";
import {
  ActionRoleSpecific,
  UserCanDoActionMemo,
  userHasLevel,
} from "../../../engine/AuthRoute";
import routes from "../../../engine/routes";
import { Link, useParams } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { AiOutlineCalendar, AiOutlineClockCircle } from "react-icons/ai";
import dayjs from "../../../utils/dayjs";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";
import { renderAdress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { RenderControl1, RenderControl2 } from "./PrestationsResumeActions";
import { useTranslation } from "react-i18next";
import { customers } from "../../../engine/customerConfig";

export const PrestationResumeCards = ({ registerRef }) => {
  const { prestation, loading, loadingAppel } = useSelector(
    state => state.prestation,
  );
  const { id } = useParams();
  const { t } = useTranslation();

  const { isMobile } = useDeviceDetect();

  const prestationRef = useRef(prestation);

  useEffect(() => {
    prestationRef.current = prestation;
  }, [prestation]);

  const {
    reference,
    status,
    languages,
    intervention,
    interventionFinal,
    interprete,
    changements,
    comment,
    institution,
    beneficiary,
    intervenant,
    billing,
    responsable,
    subStatus,
    applicant,
    isFollow,
    finalStartDate,
    finalEndDate,
  } = prestation;

  return (
    <>
      <RenderControl1 key={prestation._id} />
      <RenderControl2 key={prestation._id} />

      {status === statusPrestationsValues.draft && (
        <Alert
          message={t("prestationResumeCards.verifyInformation")}
          type={"info"}
          showIcon
          closable={true}
        />
      )}

      <Col span={24}>
        <CustomCard
          title={t("prestationResumeCards.summaryOfService")}
          openDefault={true}
          loading={loading}
        >
          <Row gutter={[10, 10]}>
            <Col span={12}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.orderNumber")}
              </span>
              <span className={"resume-strong"}>{reference}</span>
            </Col>

            <Col span={12}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.status")}
              </span>
              <span>
                {renderStatusPrestation(prestation, {
                  showControls: userHasLevel({
                    only: {
                      [roles.permanance]: "crud", //
                      [roles.admin]: "crud", //
                    },
                  }),
                })}
              </span>
            </Col>

            <Col
              span={12}
              ref={elem => registerRef("intervention.startDate", elem)}
            >
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.startDateTime")}
              </span>
              <RenderUpdatedCopy
                changesKey={"intervention.startDate"}
                data={{ "intervention.startDate": intervention.startDate }} // newStartDate should contain the updated date
              >
                <RenderDate />
              </RenderUpdatedCopy>
            </Col>
            <Col
              span={12}
              ref={elem => registerRef("intervention.endDate", elem)}
            >
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.endDateTime")}
              </span>
              <RenderUpdatedCopy
                changesKey={"intervention.endDate"}
                data={{ "intervention.endDate": intervention.endDate }} // newStartDate should contain the updated date
              >
                <RenderDate />
              </RenderUpdatedCopy>
            </Col>
            <Col span={12}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.serviceLanguage")}
              </span>
              <span className={"resume-text"}>
                {languagesList().find(e => e.value === languages[0])?.label}
              </span>
            </Col>
            <Col span={12} ref={elem => registerRef("intervention.type", elem)}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.serviceType")}
              </span>
              <RenderUpdatedCopy
                changesKey={"intervention.type"}
                data={{ "intervention.type": intervention.type }}
              >
                <RenderType />
              </RenderUpdatedCopy>
            </Col>

            {intervention?.locationName !== "" ||
            intervention?.location !== "" ? (
              <Col
                span={12}
                ref={elem => registerRef("intervention.location", elem)}
              >
                <span className={"resume-subtitle"}>
                  {t("prestationResumeCards.interventionLocation")}
                </span>

                <RenderUpdatedCopy
                  changesKey={"intervention.locationName"}
                  data={{
                    "intervention.locationName": intervention?.locationName,
                  }}
                >
                  <RenderBasic />
                </RenderUpdatedCopy>
                <RenderUpdatedCopy
                  changesKey={"intervention.location"}
                  data={{ "intervention.location": intervention?.location }}
                >
                  <RenderLocation />
                </RenderUpdatedCopy>
              </Col>
            ) : null}

            {intervention.type === typeIntervention.phone &&
            process.env.CUSTOMER_ID !== customers.sosticino ? (
              <Col span={12}>
                <span className={"resume-subtitle"}>
                  {t("prestationResumeCards.phoneNumber")}
                </span>
                <RenderUpdatedCopy
                  changesKey={"intervention.phone"}
                  data={{ "intervention.phone": intervention?.phone }}
                >
                  <RenderPhone />
                </RenderUpdatedCopy>
              </Col>
            ) : null}

            {intervention.type === typeIntervention.visio && (
              <Col span={12}>
                <span className={"resume-subtitle"}>
                  {t("prestationResumeCards.videoConferenceLink")}
                </span>
                <RenderUpdatedCopy
                  changesKey={"intervention.linkVisio"}
                  data={{
                    "intervention.linkVisio": intervention?.linkVisio,
                  }}
                >
                  <RenderLink />
                </RenderUpdatedCopy>
              </Col>
            )}

            {intervention.type === typeIntervention.phone &&
            interprete?.info?.phone ? (
              <Col span={12}>
                <span className={"resume-subtitle"}>
                  {t("prestationResumeCards.phoneNumberInterprete")}
                </span>

                <RenderUpdatedCopy
                  changesKey={"interprete?.info?.phone"}
                  data={{
                    "interprete?.info?.phone": interprete?.info?.phone,
                  }}
                >
                  <RenderPhone />
                </RenderUpdatedCopy>
              </Col>
            ) : null}

            <Col span={12}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.orderSubmissionDate")}
              </span>
              <span className={"resume-text"}>
                {prestation.applicationAt !== null
                  ? dayjs(prestation.applicationAt).format(daysJsFormat.full)
                  : "-"}
              </span>
            </Col>

            {intervention.extra !== "" && (
              <Col span={12}>
                <span className={"resume-subtitle"}>
                  {t("prestationResumeCards.locationExtra")}
                </span>
                <RenderUpdatedCopy
                  changesKey={"intervention.extra"}
                  data={{ "intervention.extra": intervention?.extra }}
                >
                  <RenderBasic />
                </RenderUpdatedCopy>
              </Col>
            )}

            {prestation?.batch_shared !== null &&
              prestation?.batch_shared !== undefined && (
                <Col span={12}>
                  <span className={"resume-subtitle"}>
                    {t("prestationResumeCards.sharedService")}
                  </span>
                  {prestation?.batch_shared?.prestations?.map(e => {
                    return (
                      <Link
                        className={` ${
                          e._id === prestation.batch_shared.mainPrestation
                            ? "strongGrouped"
                            : ""
                        }`}
                        to={routes.prestations(e._id).detail.path}
                        style={{ flex: 1 }}
                      >
                        {e.reference}{" "}
                      </Link>
                    );
                  })}
                </Col>
              )}
          </Row>
        </CustomCard>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <CustomCard
          title={t("prestationResumeCards.interpreter")}
          height={"100%"}
          loading={loading}
        >
          <Row gutter={[10, 10]}>
            <UserCanDoActionMemo
              route={routes.prestations(id).detailResume}
              action={"r"}
            >
              <>
                <Col span={24}>
                  <span className={"resume-subtitle"}>
                    {t("prestationResumeCards.interpreter")}
                  </span>
                  <span className={"resume-text"}>
                    <Link to={routes.interpretes(interprete?._id).detail.path}>
                      {renderUserName(interprete)}
                    </Link>
                  </span>
                </Col>
                <Col span={24}>
                  <span className={"resume-subtitle"}>
                    {t("prestationResumeCards.interpreterGender")}
                  </span>
                  <span className={"resume-text"}>
                    {renderUserGender(interprete)}
                  </span>
                </Col>

                {userHasLevel({
                  only: {
                    [roles.permanance]: "crud", //
                    [roles.admin]: "crud", //
                  },
                }) ? (
                  <>
                    {interventionFinal?.locationFrom ? (
                      <Col
                        span={24}
                        ref={elem => registerRef("intervention.location", elem)}
                      >
                        <span className={"resume-subtitle"}>
                          {t(
                            "prestationResumeCards.interpreterDepartureLocation",
                          )}
                        </span>
                        <RenderUpdatedCopy
                          changesKey={"interventionFinal.locationFrom"}
                          data={{
                            "interventionFinal.locationFrom":
                              interventionFinal?.locationFrom,
                          }}
                        >
                          <RenderLocation />
                        </RenderUpdatedCopy>
                      </Col>
                    ) : (
                      <Col
                        className={"non-printable"}
                        span={24}
                        ref={elem => registerRef("intervention.location", elem)}
                      >
                        <span className={"resume-subtitle"}>
                          {t(
                            "prestationResumeCards.interpreterDepartureLocation",
                          )}
                        </span>
                        <RenderUpdatedCopy
                          changesKey={"intervention.locationFrom"}
                          data={{
                            "intervention.locationFrom":
                              intervention?.locationFrom,
                          }}
                        >
                          <RenderLocation />
                        </RenderUpdatedCopy>
                      </Col>
                    )}
                  </>
                ) : null}

                <ActionRoleSpecific
                  only={[roles.admin, roles.permanance, roles.institution]}
                >
                  <Col span={24}>
                    <span className={"resume-subtitle"}>
                      {t("prestationResumeCards.institutionComment")}
                    </span>
                    <RenderUpdatedCopy
                      changesKey={"comment.internal"}
                      data={{
                        "comment.internal": comment?.internal || "-",
                      }}
                    >
                      <RenderBasic />
                    </RenderUpdatedCopy>
                  </Col>
                </ActionRoleSpecific>
              </>
            </UserCanDoActionMemo>

            <Col span={24} className={"non-printable"}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.interpreterComment")}
              </span>
              <RenderUpdatedCopy
                changesKey={"comment.interprete"}
                data={{ "comment.interprete": comment?.interprete || "-" }}
              >
                <RenderBasic />
              </RenderUpdatedCopy>
            </Col>
          </Row>
        </CustomCard>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <CustomCard
          title={t("prestationResumeCards.institution")}
          height={"100%"}
          loading={loading}
        >
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.institution")}
              </span>
              <span className={"resume-text"}>
                <Link to={routes.institutions(institution?._id).detail.path}>
                  {institution?.name}
                </Link>
              </span>
            </Col>
            <Col span={24}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.invoiceSentTo")}
              </span>
              <span className={""}>
                <b>{renderAdress(billing, false, prestation.institution)}</b>
              </span>
            </Col>
            <Col span={24}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.beneficiaryReferences")}
              </span>
              <Space direction={"vertical"}>
                <RenderUpdatedCopy
                  changesKey={"beneficiary.reference"}
                  data={{ "beneficiary.reference": beneficiary?.reference }}
                >
                  <RenderBasic theme={"light"} />
                </RenderUpdatedCopy>

                <RenderUpdatedCopy
                  changesKey={"beneficiary.lastname"}
                  data={{ "beneficiary.lastname": beneficiary?.lastname }}
                >
                  <RenderBasic theme={"light"} width={"auto"} />
                </RenderUpdatedCopy>
                <RenderUpdatedCopy
                  changesKey={"beneficiary.firstname"}
                  data={{ "beneficiary.firstname": beneficiary?.firstname }}
                >
                  <RenderBasic theme={"light"} width={"auto"} />
                </RenderUpdatedCopy>
                <RenderUpdatedCopy
                  changesKey={"beneficiary.birthday"}
                  data={{ "beneficiary.birthday": beneficiary?.birthday }}
                >
                  <RenderBasic theme={"light"} width={"auto"} />
                </RenderUpdatedCopy>
                <RenderUpdatedCopy
                    changesKey={"beneficiary.country"}
                    data={{ "beneficiary.country": beneficiary?.country }}
                >
                  <RenderBasic theme={"light"} width={"auto"} />
                </RenderUpdatedCopy>
                {beneficiary?.genre !== "" ? (
                  <RenderUpdatedCopy
                    changesKey={"beneficiary.genre"}
                    data={{
                      "beneficiary.genre":
                        beneficiary?.genre === "female"
                          ? t("prestationInputs.femaleG")
                          : t("prestationInputs.maleG"),
                    }}
                    // t("prestationInformations.beneficiaryDate")
                  >
                    <RenderBasic theme={"light"} width={"auto"} />
                  </RenderUpdatedCopy>
                ) : null}

                <RenderUpdatedCopy
                  changesKey={"beneficiary.n"}
                  data={{ "beneficiary.n": beneficiary?.n }}
                >
                  <RenderBasic theme={"light"} width={"auto"} extra={"(N) "} />
                </RenderUpdatedCopy>
                <RenderUpdatedCopy
                  changesKey={"beneficiary.simic"}
                  data={{ "beneficiary.simic": beneficiary?.simic }}
                >
                  <RenderBasic
                    theme={"light"}
                    width={"auto"}
                    extra={"(SIMIC) "}
                  />
                </RenderUpdatedCopy>
              </Space>
            </Col>
            <Col span={24}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.responsiblePersonnel")}
              </span>
              <span className={"resume-text"}>
                {renderResponsable(responsable)}
              </span>
              <span className={"resume-text"}>
                {responsable?.phone} {renderPhoneClickable(responsable?.phone)}
              </span>
              <span className={"resume-text"}>
                {renderEmailClickable(responsable?.email)}
              </span>
            </Col>
            <Col span={24}>
              <span className={"resume-subtitle"}>
                {t("prestationResumeCards.applicant")}
              </span>
              <span className={"resume-text"}>{renderUserName(applicant)}</span>
              <span className={"resume-text non-printable"}>
                {applicant?.info?.phone}{" "}
                {renderPhoneClickable(applicant?.info?.phone)}
              </span>

              <span className={"resume-text non-printable"}>
                {renderEmailClickable(applicant?.email)}
              </span>
            </Col>
          </Row>
        </CustomCard>
      </Col>
    </>
  );
};

export const RenderDate = props => (
  <div style={{ width: "100%" }}>
    <Space direction={"horizontal"} className={props.className}>
      <span className={"resume-text"}>
        <AiOutlineCalendar size={20} />
        {dayjs(props[props.dataKey]).format(daysJsFormat.day)}
      </span>
      <span className={"resume-text"}>
        <AiOutlineClockCircle size={20} />
        {dayjs(props[props.dataKey]).format(daysJsFormat.hour)}
      </span>
    </Space>
  </div>
);

export const RenderDateString = ({ value }) => {
  return (
    <div style={{ width: "100%" }}>
      <Space direction={"horizontal"}>
        <span className={"resume-text"}>
          <AiOutlineCalendar size={20} />
          {value}
        </span>
      </Space>
    </div>
  );
};

const RenderType = props => (
  <div style={{ width: "100%" }}>
    <span className={" resume-text"}>
      <b className={props.className}>
        {renderTypePrestation(props[props.dataKey])}
      </b>
    </span>
  </div>
);

const RenderLocation = props => (
  <div style={{ width: "100%" }}>
    <a
      className={props.className}
      href={`https://www.google.com/maps/search/?api=1&query=${
        props[props.dataKey]
      }`}
      target={"_blank"}
    >
      {props[props.dataKey]}
    </a>
  </div>
);

const RenderLink = props => (
  <div style={{ width: "100%" }}>
    <a
      className={props.className}
      href={`${props[props.dataKey]}`}
      target={"_blank"}
    >
      {props[props.dataKey]}
    </a>
  </div>
);

const RenderBasic = props => {
  if (props[props.dataKey] === "") {
    return null;
  }

  let { extra = "" } = props;

  return (
    <div style={{ width: props.width || "100%" }}>
      <span className={" resume-text"}>
        {props.theme === "light" ? (
          <span className={props.className}>
            {extra}
            {props[props.dataKey]}
          </span>
        ) : (
          <b className={props.className}>
            {extra}
            {props[props.dataKey]}
          </b>
        )}
      </span>
    </div>
  );
};

const RenderPhone = props => (
  <div style={{ width: props.width || "100%" }}>
    <span className={" resume-text"}>
      {props.theme === "light" ? (
        <span className={props.className}>{props[props.dataKey]}</span>
      ) : (
        <>
          <b className={props.className}>{props[props.dataKey]}</b>
          {renderPhoneClickable(props[props.dataKey])}
        </>
      )}
    </span>
  </div>
);
